var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 725.5 219.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 570.91,
    y1: 41.74,
    x2: 607.49,
    y2: 50.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fdfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#eaeff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d9e3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c3d3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a8bfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#88a8d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658ec9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 643.86,
    y1: 92.08,
    x2: 635.45,
    y2: 12.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#dae3ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#aec1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7394c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6388be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658ec9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 658.29,
    y1: 40.81,
    x2: 728.88,
    y2: 61.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dbe4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#bbcde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a0b9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8aa9d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#799dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6d94cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#668fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658ec9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 432.58,
    y1: 160.1,
    x2: 725.5,
    y2: 160.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#658ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b92cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bacce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ebf1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 459.42,
    y1: 131.57,
    x2: 475.41,
    y2: 131.57,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.38,187.15c-3.72.07-5.48-1.7-7.47-2.83q-7.92-4.49-13.55,3.16c-4.54,6.17-9.12,12.32-13.68,18.48.07-10.71-.27-21.44.11-32.14.19-5.24-1.5-8.67-5.75-11.92-15.8-12.09-31.25-24.61-46.84-36.97-1.63-1.29-3.22-2.64-4.96-3.77-.62-.4-1.77-.55-2.4-.25-1.25.59-1.31,1.92-.7,3.01,1.15,2.07,2.43,4.08,3.73,6.07,10.35,15.88,20.71,31.76,31.13,47.72-3.5,3.53-7.95,4.6-11.9,6.44-20.96,9.74-42.09,19.11-62.97,29.02-9.66,4.58-17.87,3.86-26.34-2.91C88.7,177.48,47.42,144.96,6.22,112.35c-.47-.37-.93-.74-1.38-1.13-6.8-5.7-6.6-7.8,1.69-11.6,54.16-24.85,108.36-49.62,162.54-74.42,13.48-6.17,27.03-12.19,40.4-18.59,9.28-4.44,17.4-3.67,25.59,2.86,41.32,32.95,82.81,65.68,124.24,98.49.93.74,1.89,1.45,2.75,2.26,4.37,4.12,4.2,6.62-1.38,9.28-13.11,6.24-26.38,12.14-39.59,18.18-7.82,3.57-15.5,7.49-23.5,10.58-5.05,1.95-6.49,4.9-6.29,10.03.37,9.46.1,18.95.1,28.85ZM194.8,117.98c-.2.2-.59.44-.56.59.09.42.36.8.56,1.2.2-.2.59-.44.56-.59-.09-.42-.36-.8-.56-1.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M499.16,0v85.45c0,3.74-1.87,5.6-5.6,5.6h-9.71v-40.33h-37.19v34.73c0,3.74-1.82,5.6-5.47,5.6h-9.84V6.15c0-4.1,1.87-6.15,5.61-6.15h9.71v35.41h37.19V5.47c0-3.65,1.73-5.47,5.2-5.47h10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.23,51.41c0,3.55-.53,6.52-1.57,8.89-1.05,2.37-2.49,4.19-4.31,5.47-1.82,1.28-4.01,2.19-6.56,2.73-2.55.55-5.38.82-8.48.82h-16c.73,3.46,2.37,5.86,4.92,7.18,2.55,1.32,5.51,1.98,8.89,1.98,2.92,0,5.24-.27,6.97-.82,1.73-.55,3.78-1.27,6.15-2.19,1.82-.55,3.21-.43,4.17.34.96.78,1.44,2.03,1.44,3.76v8.07c-1.91.82-3.85,1.53-5.81,2.12-1.96.59-4.08,1.09-6.36,1.5-2.28.41-4.6.62-6.97.62-2.65,0-5.63-.34-8.95-1.03-3.33-.68-6.47-2.03-9.43-4.03-2.96-2-5.47-4.88-7.52-8.61-2.05-3.74-3.08-8.79-3.08-15.18,0-7.75,1.05-13.69,3.14-17.84,2.1-4.15,4.63-7.31,7.59-9.5,2.96-2.19,6.06-3.6,9.3-4.24,3.23-.64,5.99-.96,8.27-.96,2.46,0,5.1.36,7.93,1.09,2.82.73,5.45,1.91,7.86,3.55,2.41,1.64,4.42,3.81,6.02,6.5,1.59,2.69,2.39,5.95,2.39,9.77ZM536.48,56.46c4.28,0,7.25-.29,8.89-.89,1.64-.59,2.46-1.85,2.46-3.76,0-2.74-.98-4.85-2.94-6.36-1.96-1.5-4.54-2.26-7.72-2.26-2.28,0-4.24.36-5.88,1.09-1.64.73-3.01,1.71-4.1,2.94s-1.96,2.55-2.6,3.96c-.64,1.41-1.09,3.17-1.37,5.26h13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.46,3.15c2.64,0,5.42.27,8.34.82,2.92.55,5.29,1.05,7.11,1.5-.18,2.73-.36,4.65-.55,5.74-.18,1.09-.46,2.28-.82,3.55-.55,1.82-1.23,2.96-2.05,3.42-.82.46-2.37.41-4.65-.14-.73-.18-1.69-.32-2.87-.41-1.19-.09-2.28-.14-3.28-.14-2.1,0-3.99.39-5.67,1.16-1.69.78-2.53,2.3-2.53,4.58v8.2h16.41v8.61c0,3.74-1.82,5.61-5.47,5.61h-10.94v39.92c0,3.65-1.82,5.47-5.47,5.47h-9.84v-45.39h-5.88v-8.34c0-3.92,1.96-5.88,5.88-5.88v-10.8c0-3.37.64-6.17,1.91-8.41,1.28-2.23,3.01-4.03,5.2-5.4,2.19-1.37,4.58-2.32,7.18-2.87,2.6-.55,5.26-.82,8-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M639.02,46.35v26.39c0,1.91.55,3.21,1.64,3.9,1.09.68,2.96,1.03,5.6,1.03,1,0,1.98-.07,2.94-.2s2.21-.34,3.76-.61c1.91-.36,3.26-.16,4.03.61.77.78,1.16,2.12,1.16,4.03v6.97c-.91.73-2.69,1.48-5.33,2.26-2.65.77-5.7,1.16-9.16,1.16-2.19,0-4.49-.32-6.9-.96-2.42-.64-4.58-1.69-6.49-3.15-1.91-1.46-3.49-3.35-4.72-5.67-1.23-2.32-1.85-5.17-1.85-8.54V14.63l9.3-2.19c.45-.09,1.03-.18,1.71-.27.68-.09,1.34-.02,1.98.2.64.23,1.18.68,1.64,1.37.45.68.68,1.8.68,3.35v14.35h16.82v9.16c0,3.83-1.78,5.74-5.33,5.74h-11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M697.94,31.44c8.2,0,14.17,1.76,17.91,5.26,3.74,3.51,5.6,8.5,5.6,14.97v34.04c0,3.55-1.69,5.33-5.06,5.33h-10.25v-39.65c0-4.56-2.73-6.84-8.2-6.84-2.37,0-4.63.2-6.77.61-2.14.41-4.12.98-5.95,1.71v38.55c0,3.74-1.6,5.6-4.79,5.6h-10.53V.27h9.3c4.01,0,6.02,2,6.02,6.01v27.34c2-.73,4.12-1.28,6.36-1.64,2.23-.36,4.35-.55,6.36-.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M572.72,180.51c-1.77-2.54-3.29-4.99-4.17-7.77-1.11-3.51-.87-7.08-.31-10.64.45-2.84,1.29-5.55,2.77-8.03,2.39-4.04,5.98-6.54,10.36-7.99,4.68-1.54,9.49-1.7,14.35-1.18,2.99.32,5.86,1.05,8.54,2.44,4.45,2.31,7.43,5.96,9.14,10.6,1.8,4.88,2.36,9.89.86,14.97-.74,2.52-2.15,4.73-3.6,6.9-.12.18-.25.35-.38.52.23.32.54.18.79.18,16.83,0,33.65,0,50.48,0,16.48,0,32.96,0,49.44.02.92,0,1.14-.22,1.11-1.12-.1-3.71.11-7.43-.23-11.14-.19-2.05-.59-4.05-1.81-5.76-1.46-2.05-3.62-2.96-5.99-3.4-4.07-.76-8.16-.45-12.24-.11-3.57.29-7.09.99-10.6,1.73-2.93.62-5.01-.78-5.66-3.69-.51-2.26-1.01-4.53-1.55-6.78-.12-.5-.13-.68.46-.82,6.18-1.5,12.42-2.58,18.74-3.19,4.15-.4,8.31-.39,12.45.04,3.74.38,7.37,1.25,10.65,3.18,4.39,2.57,6.77,6.58,8.01,11.38.93,3.56,1.18,7.19,1.19,10.84,0,3.75-.02,7.5-.05,11.24-.02,1.61-.35,3.18-.85,4.71-1.06,3.25-3.35,5.05-6.65,5.67-1.46.27-2.93.4-4.41.39-65.83,0-131.65,0-197.48-.02-4.12,0-7.87-1.45-11.4-3.47-.71-.4-1.15-.37-1.81.04-3.62,2.26-7.55,3.45-11.86,3.45-19.16-.02-38.32-.01-57.48,0-.72,0-.96-.15-.94-.91.05-2.49,0-4.98.03-7.46.04-2.64,1.18-4.23,3.29-4.62.68-.13,1.38-.22,2.06-.18.81.05,1.04-.16,1.04-1.02-.03-15.56-.02-31.12-.02-46.68,0-.94,0-1.88.21-2.81.4-1.68,1.69-2.95,3.42-3.23,2.41-.39,4.84-.11,7.26-.18.88-.02,2.05-.31,2.55.13.59.51.18,1.71.18,2.61.02,7.12.02,14.24,0,21.36,0,.73.15.96.91.83,6.11-1,12.22-1.97,18.33-2.94,6.11-.97,12.21-2.02,18.34-2.89,4.54-.64,8.61.77,12.36,3.31,6.24,4.22,9.13,10.23,9.64,17.58.3,4.33.05,8.61-1.31,12.77-.24.74.02,1.07.77,1.1.5.01,1.01.04,1.51.04,14.71,0,29.43,0,44.14,0,4.79,0,9.58,0,14.37,0,.3,0,.61,0,1.06,0ZM471.57,180.51s0-.02,0-.03c5.95,0,11.91.1,17.86-.03,5.49-.12,9.19-3.86,9.58-8.67.3-3.67-.1-7.19-2.6-10.12-1.94-2.27-4.46-3.38-7.45-2.94-3.73.54-7.43,1.24-11.15,1.87-8.11,1.37-16.22,2.76-24.34,4.09-.82.13-.89.44-.89,1.13.03,4.6.03,9.2,0,13.79,0,.74.19.92.92.92,6.02-.03,12.03-.02,18.05-.02ZM602,167.33c-.04-2.48-.66-4.77-2.33-6.69-2.5-2.88-5.75-3.76-9.41-3.52-2.13.14-4.21.51-5.89,1.93-3.74,3.15-5.25,10.63-.64,15.37,2.21,2.27,4.72,4.14,7.38,5.83.35.22.59.19.92-.02,2.93-1.88,5.66-3.98,7.71-6.84,1.3-1.81,2.31-3.74,2.26-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.73,211.67c0,.41,0,.82,0,1.23,0,1.35,0,1.33-1.29,1.56-7.54,1.36-15.07,2.72-22.61,4.09-2.44.44-4.88.9-7.32,1.31-2.07.35-3.73-1.07-3.77-3.17-.02-1.04.02-2.08-.01-3.12-.02-.53.11-.74.69-.84,5.5-.96,11-1.98,16.5-2.97,4.73-.85,9.46-1.68,14.18-2.55,2.19-.4,3.57.64,3.64,2.86.02.53,0,1.07,0,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.42,131.42c.02-4.37,3.57-7.86,7.96-7.85,4.4.01,8.05,3.62,8.03,7.93-.03,4.46-3.72,8.14-8.11,8.08-4.45-.07-7.9-3.64-7.88-8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599.58,127.35c-.14,4.6-3.77,8.06-8.3,7.92-4.46-.14-7.77-3.8-7.63-8.44.12-4.05,3.52-7.6,7.96-7.54,4.56.06,8.1,3.75,7.97,8.05Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.8c9fee19e1e0e739d451f6c56506f440.svg";
export { ForwardRef as ReactComponent };